export const HERO_BANNERS = [
  {
    title: 'Stop Losing 10+ Hours a Week to Manual Work',
    message:
      'Your team is doing the same repetitive tasks over and over. Custom automation software can handle it in seconds—freeing your best people to focus on work that actually grows the business. Most clients see ROI within 30 days.',
  },
  {
    title: 'Your Competitors Are Automating. Are You?',
    message:
      'Every hour spent on manual processes is an hour your competition uses to get ahead. We build custom software that automates your workflows, cuts errors, and lets you move faster than companies twice your size.',
  },
  {
    title: '$0 Upfront. Pay Only When It Works.',
    message:
      'We take on all the development risk. You pay nothing until your custom solution is live and delivering value. No deposits, no milestone payments, no contracts to escape. If it does not work, you owe us nothing.',
  },
  {
    title: 'Working Prototype in 2 Weeks, Not 6 Months',
    message:
      'Traditional software projects drag on forever. We deliver a functional prototype you can test in days—not months. See real progress immediately, provide feedback, and get to launch faster than you thought possible.',
  },
  {
    title: 'The Software Your Business Actually Needs',
    message:
      'Off-the-shelf tools force you to change how you work. Custom software adapts to your processes, integrates with your existing tools, and solves the exact problems keeping you up at night.',
  },
  {
    title: '100+ Projects. 38+ Happy Clients. 15+ Years.',
    message:
      'We have built software for startups, enterprises, and everything in between. Our track record speaks for itself—and our clients stick around because we deliver results, not excuses.',
  },
  {
    title: 'What Could You Do With 20 Extra Hours a Week?',
    message:
      'Automation does not just save time—it creates opportunity. When your team stops doing busywork, they start doing breakthrough work. We help you reclaim the hours you are losing to inefficiency.',
  },
  {
    title: 'Enterprise Power. Startup Speed. Fair Pricing.',
    message:
      'Get the reliability and scale of enterprise software without the 6-figure price tag or 18-month timeline. We build solutions that adapt to your size and grow as you grow.',
  },
  {
    title: 'Your Data Is a Goldmine. Start Mining It.',
    message:
      'You are sitting on insights that could transform your business—but they are buried in spreadsheets and disconnected systems. We build dashboards and reports that surface what matters most.',
  },
  {
    title: 'Free Strategy Call. Real Automation Ideas.',
    message:
      'In 30 minutes, we will identify your biggest automation opportunities and show you exactly what is possible. No sales pitch, no pressure—just actionable ideas you can use whether you work with us or not.',
  },
] as const

export type HeroBanner = typeof HERO_BANNERS[number]
